import { TrackJS, type TrackJSErrorPayload } from 'trackjs';

import type { DatadogRumContext, Environment } from '../types';

import {
  track as ddTrack,
  logError as ddLogError,
  configureErrorTracking as ddConfigureErrorTracking,
} from './datadogRum';

export const track = (e: Error | string | any): void => {
  if (TrackJS.isInstalled()) {
    TrackJS.track(e);
  } else {
    // eslint-disable-next-line no-console
    console.error(e);
  }
  ddTrack(e);
};

export const logError = (...args: any[]): void => {
  if (TrackJS.isInstalled()) {
    TrackJS.console.error(...args);
  } else {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
  ddLogError(args[0], args[1]);
};

/**
 * This function will not send the event to TrackJS. If flushing is required, Please use `track` or `logError` functions.
 */
export const log = (...args: any[]): void => {
  if (TrackJS.isInstalled()) {
    TrackJS.console.log(...args);
  } else {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
};

export const onError = (payload: TrackJSErrorPayload) =>
  !/^401 : POST https:\/\/(?:[\w.])*\/usernamepassword\/login$/.test(
    payload.message,
  );

export const configureErrorTracking = (
  enviroment: Environment,
  context: DatadogRumContext,
) => {
  try {
    const application =
      enviroment === 'production'
        ? 'oi-auth0-hosted-pages'
        : 'oi-auth0-hosted-pages-dev';

    TrackJS.install({
      token: 'c0dee68c9f294d4d8011e8e45b0a74ec',
      application,
      onError,
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('An error occured setting up error reporting', error);
  }
  ddConfigureErrorTracking(enviroment, context);
};
